/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'chat.bsky.moderation.subscribeModEvents'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $message = /*#__PURE__*/ l.typedUnion(
  [
    /*#__PURE__*/ l.typedRef<EventConvoFirstMessage>(
      (() => eventConvoFirstMessage) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatCreated>(
      (() => eventGroupChatCreated) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatMemberAdded>(
      (() => eventGroupChatMemberAdded) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatMemberJoined>(
      (() => eventGroupChatMemberJoined) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatJoinRequest>(
      (() => eventGroupChatJoinRequest) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatJoinRequestApproved>(
      (() => eventGroupChatJoinRequestApproved) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatJoinRequestRejected>(
      (() => eventGroupChatJoinRequestRejected) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventChatAccepted>(
      (() => eventChatAccepted) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatMemberLeft>(
      (() => eventGroupChatMemberLeft) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatUpdated>(
      (() => eventGroupChatUpdated) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventRateLimitExceeded>(
      (() => eventRateLimitExceeded) as any,
    ),
  ],
  false,
)

export type $Message = l.InferOutput<typeof $message>

/** Subscribe to stream of chat events targeted to moderation. Private endpoint. */
const main = /*#__PURE__*/ l.subscription($nsid, $params, $message, [
  'FutureCursor',
  'ConsumerTooSlow',
])

export { main }

export const $lxm = $nsid

/** Fired when the first message was sent on a convo. */
type EventConvoFirstMessage = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventConvoFirstMessage'
  convoId: string
  createdAt: l.DatetimeString
  messageId?: string

  /**
   * The list of DIDs message recipients. Does not include the sender, which is in the `user` field
   */
  recipients: l.DidString[]
  rev: string

  /**
   * The DID of the message author.
   */
  user: l.DidString
}

export type { EventConvoFirstMessage }

/** Fired when the first message was sent on a convo. */
const eventConvoFirstMessage =
  /*#__PURE__*/ l.typedObject<EventConvoFirstMessage>(
    $nsid,
    'eventConvoFirstMessage',
    /*#__PURE__*/ l.object({
      convoId: /*#__PURE__*/ l.string(),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      messageId: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      recipients: /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.string({ format: 'did' }),
      ),
      rev: /*#__PURE__*/ l.string(),
      user: /*#__PURE__*/ l.string({ format: 'did' }),
    }),
  )

export { eventConvoFirstMessage }

/** Fire when a group chat is created. */
type EventGroupChatCreated = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatCreated'

  /**
   * The DID of the actor performing the action. For this event, same as ownerDid.
   */
  actorDid: l.DidString

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString
  convoId: string
  createdAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number

  /**
   * The name set at creation time.
   */
  groupName: string

  /**
   * DIDs of everyone added at creation time.
   */
  initialMemberDids: l.DidString[]

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  rev: string
}

export type { EventGroupChatCreated }

/** Fire when a group chat is created. */
const eventGroupChatCreated =
  /*#__PURE__*/ l.typedObject<EventGroupChatCreated>(
    $nsid,
    'eventGroupChatCreated',
    /*#__PURE__*/ l.object({
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      convoId: /*#__PURE__*/ l.string(),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
      groupName: /*#__PURE__*/ l.string(),
      initialMemberDids: /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.string({ format: 'did' }),
      ),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      rev: /*#__PURE__*/ l.string(),
    }),
  )

export { eventGroupChatCreated }

/** Fired when a member is added to a group chat. Note that members are added in the 'request' state. */
type EventGroupChatMemberAdded = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatMemberAdded'

  /**
   * The DID of the actor performing the action. For this event, same as ownerDid.
   */
  actorDid: l.DidString

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString
  convoId: string
  createdAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number
  groupName: string

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString

  /**
   * The number of members who have not yet accepted the convo.
   */
  requestMembersCount: number
  rev: string

  /**
   * The DID of the member who was added.
   */
  subjectDid: l.DidString

  /**
   * Whether the added member follows the group owner.
   */
  subjectFollowsOwner: boolean
}

export type { EventGroupChatMemberAdded }

/** Fired when a member is added to a group chat. Note that members are added in the 'request' state. */
const eventGroupChatMemberAdded =
  /*#__PURE__*/ l.typedObject<EventGroupChatMemberAdded>(
    $nsid,
    'eventGroupChatMemberAdded',
    /*#__PURE__*/ l.object({
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      convoId: /*#__PURE__*/ l.string(),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
      groupName: /*#__PURE__*/ l.string(),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      requestMembersCount: /*#__PURE__*/ l.integer(),
      rev: /*#__PURE__*/ l.string(),
      subjectDid: /*#__PURE__*/ l.string({ format: 'did' }),
      subjectFollowsOwner: /*#__PURE__*/ l.boolean(),
    }),
  )

export { eventGroupChatMemberAdded }

/** Fired when a member joins a group chat via an join link that does not require approval. */
type EventGroupChatMemberJoined = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatMemberJoined'

  /**
   * The DID of the person joining.
   */
  actorDid: l.DidString

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString
  convoId: string
  createdAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number
  groupName: string

  /**
   * The code of the join link used to join.
   */
  joinLinkCode: string

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  rev: string

  /**
   * Whether the joining member follows the group owner.
   */
  subjectFollowsOwner: boolean
}

export type { EventGroupChatMemberJoined }

/** Fired when a member joins a group chat via an join link that does not require approval. */
const eventGroupChatMemberJoined =
  /*#__PURE__*/ l.typedObject<EventGroupChatMemberJoined>(
    $nsid,
    'eventGroupChatMemberJoined',
    /*#__PURE__*/ l.object({
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      convoId: /*#__PURE__*/ l.string(),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
      groupName: /*#__PURE__*/ l.string(),
      joinLinkCode: /*#__PURE__*/ l.string(),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      rev: /*#__PURE__*/ l.string(),
      subjectFollowsOwner: /*#__PURE__*/ l.boolean(),
    }),
  )

export { eventGroupChatMemberJoined }

/** Fired when a user requests to join a group chat via an join link that requires approval. */
type EventGroupChatJoinRequest = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatJoinRequest'

  /**
   * The DID of the person requesting to join.
   */
  actorDid: l.DidString

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString
  convoId: string
  createdAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number
  groupName: string

  /**
   * The code of the join link used to request joining.
   */
  joinLinkCode: string

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  rev: string

  /**
   * Whether the requesting member follows the group owner.
   */
  subjectFollowsOwner: boolean
}

export type { EventGroupChatJoinRequest }

/** Fired when a user requests to join a group chat via an join link that requires approval. */
const eventGroupChatJoinRequest =
  /*#__PURE__*/ l.typedObject<EventGroupChatJoinRequest>(
    $nsid,
    'eventGroupChatJoinRequest',
    /*#__PURE__*/ l.object({
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      convoId: /*#__PURE__*/ l.string(),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
      groupName: /*#__PURE__*/ l.string(),
      joinLinkCode: /*#__PURE__*/ l.string(),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      rev: /*#__PURE__*/ l.string(),
      subjectFollowsOwner: /*#__PURE__*/ l.boolean(),
    }),
  )

export { eventGroupChatJoinRequest }

/** Fired when a join request is approved by the group owner. */
type EventGroupChatJoinRequestApproved = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatJoinRequestApproved'

  /**
   * The DID of the owner approving the request.
   */
  actorDid: l.DidString

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString
  convoId: string
  createdAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number
  groupName: string

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  rev: string

  /**
   * The DID of the member whose request was approved.
   */
  subjectDid: l.DidString
}

export type { EventGroupChatJoinRequestApproved }

/** Fired when a join request is approved by the group owner. */
const eventGroupChatJoinRequestApproved =
  /*#__PURE__*/ l.typedObject<EventGroupChatJoinRequestApproved>(
    $nsid,
    'eventGroupChatJoinRequestApproved',
    /*#__PURE__*/ l.object({
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      convoId: /*#__PURE__*/ l.string(),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
      groupName: /*#__PURE__*/ l.string(),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      rev: /*#__PURE__*/ l.string(),
      subjectDid: /*#__PURE__*/ l.string({ format: 'did' }),
    }),
  )

export { eventGroupChatJoinRequestApproved }

/** Fired when a join request is rejected by the group owner. */
type EventGroupChatJoinRequestRejected = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatJoinRequestRejected'

  /**
   * The DID of the owner rejecting the request.
   */
  actorDid: l.DidString

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString
  convoId: string
  createdAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number
  groupName: string

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  rev: string

  /**
   * The DID of the member whose request was rejected.
   */
  subjectDid: l.DidString
}

export type { EventGroupChatJoinRequestRejected }

/** Fired when a join request is rejected by the group owner. */
const eventGroupChatJoinRequestRejected =
  /*#__PURE__*/ l.typedObject<EventGroupChatJoinRequestRejected>(
    $nsid,
    'eventGroupChatJoinRequestRejected',
    /*#__PURE__*/ l.object({
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      convoId: /*#__PURE__*/ l.string(),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
      groupName: /*#__PURE__*/ l.string(),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      rev: /*#__PURE__*/ l.string(),
      subjectDid: /*#__PURE__*/ l.string({ format: 'did' }),
    }),
  )

export { eventGroupChatJoinRequestRejected }

/** Fired when a user accepts a chat convo, either explicitly or by sending a message. */
type EventChatAccepted = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventChatAccepted'

  /**
   * The DID of the person accepting the convo.
   */
  actorDid: l.DidString

  /**
   * When the convo was originally created.
   */
  convoCreatedAt: l.DatetimeString
  convoId: string
  createdAt: l.DatetimeString

  /**
   * Current member count at the time of the event. Only present for group convos.
   */
  groupMemberCount?: number

  /**
   * The name of the group chat. Only present for group convos.
   */
  groupName?: string

  /**
   * How the convo was accepted.
   */
  method: 'explicit' | 'message' | l.UnknownString

  /**
   * The DID of the group chat owner. Only present for group convos.
   */
  ownerDid?: l.DidString
  rev: string
}

export type { EventChatAccepted }

/** Fired when a user accepts a chat convo, either explicitly or by sending a message. */
const eventChatAccepted = /*#__PURE__*/ l.typedObject<EventChatAccepted>(
  $nsid,
  'eventChatAccepted',
  /*#__PURE__*/ l.object({
    actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
    convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    convoId: /*#__PURE__*/ l.string(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    groupMemberCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    groupName: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    method: /*#__PURE__*/ l.string<{ knownValues: ['explicit', 'message'] }>(),
    ownerDid: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'did' }),
    ),
    rev: /*#__PURE__*/ l.string(),
  }),
)

export { eventChatAccepted }

/** Fired when a member leaves or is removed from a group chat. */
type EventGroupChatMemberLeft = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatMemberLeft'

  /**
   * The DID of the actor. For voluntary: the person leaving. For kicked: the owner.
   */
  actorDid: l.DidString

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString
  convoId: string
  createdAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number
  groupName: string

  /**
   * How the member left.
   */
  leaveMethod: 'voluntary' | 'kicked' | l.UnknownString

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  rev: string

  /**
   * The DID of the member who left or was removed.
   */
  subjectDid: l.DidString
}

export type { EventGroupChatMemberLeft }

/** Fired when a member leaves or is removed from a group chat. */
const eventGroupChatMemberLeft =
  /*#__PURE__*/ l.typedObject<EventGroupChatMemberLeft>(
    $nsid,
    'eventGroupChatMemberLeft',
    /*#__PURE__*/ l.object({
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      convoId: /*#__PURE__*/ l.string(),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
      groupName: /*#__PURE__*/ l.string(),
      leaveMethod: /*#__PURE__*/ l.string<{
        knownValues: ['voluntary', 'kicked']
      }>(),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      rev: /*#__PURE__*/ l.string(),
      subjectDid: /*#__PURE__*/ l.string({ format: 'did' }),
    }),
  )

export { eventGroupChatMemberLeft }

/** Fired when a group chat's metadata or status changes. */
type EventGroupChatUpdated = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatUpdated'

  /**
   * The DID of the actor performing the action (the owner).
   */
  actorDid: l.DidString

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString
  convoId: string
  createdAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number

  /**
   * Current group name.
   */
  groupName: string

  /**
   * The code of the join link. Only present when updateType is join-link-related.
   */
  joinLinkCode?: string

  /**
   * Whether the join link is restricted to followers of the owner. Only present when updateType is join-link-related.
   */
  joinLinkFollowersOnly?: boolean

  /**
   * Whether the join link requires owner approval to join. Only present when updateType is join-link-related.
   */
  joinLinkRequiresApproval?: boolean

  /**
   * Why the group was locked. Only present when updateType is 'locked'.
   */
  lockReason?:
    | 'owner_action'
    | 'owner_left'
    | 'owner_deactivated'
    | 'owner_deleted'
    | 'owner_suspended'
    | 'owner_taken_down'
    | 'label_applied'
    | 'convo_taken_down'
    | l.UnknownString

  /**
   * The new group name. Only present when updateType is 'name_changed'.
   */
  newName?: string

  /**
   * The previous group name. Only present when updateType is 'name_changed'.
   */
  oldName?: string

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  rev: string

  /**
   * What changed.
   */
  updateType:
    | 'name_changed'
    | 'locked'
    | 'locked_permanently'
    | 'unlocked'
    | 'join_link_created'
    | 'join_link_disabled'
    | 'join_link_settings_changed'
    | l.UnknownString
}

export type { EventGroupChatUpdated }

/** Fired when a group chat's metadata or status changes. */
const eventGroupChatUpdated =
  /*#__PURE__*/ l.typedObject<EventGroupChatUpdated>(
    $nsid,
    'eventGroupChatUpdated',
    /*#__PURE__*/ l.object({
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      convoId: /*#__PURE__*/ l.string(),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
      groupName: /*#__PURE__*/ l.string(),
      joinLinkCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      joinLinkFollowersOnly: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.boolean(),
      ),
      joinLinkRequiresApproval: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.boolean(),
      ),
      lockReason: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.string<{
          knownValues: [
            'owner_action',
            'owner_left',
            'owner_deactivated',
            'owner_deleted',
            'owner_suspended',
            'owner_taken_down',
            'label_applied',
            'convo_taken_down',
          ]
        }>(),
      ),
      newName: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      oldName: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      rev: /*#__PURE__*/ l.string(),
      updateType: /*#__PURE__*/ l.string<{
        knownValues: [
          'name_changed',
          'locked',
          'locked_permanently',
          'unlocked',
          'join_link_created',
          'join_link_disabled',
          'join_link_settings_changed',
        ]
      }>(),
    }),
  )

export { eventGroupChatUpdated }

/** Fired when a user exceeds a rate limit. */
type EventRateLimitExceeded = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventRateLimitExceeded'

  /**
   * The DID of the user who hit the rate limit.
   */
  actorDid: l.DidString
  createdAt: l.DatetimeString

  /**
   * The NSID of the endpoint that was rate limited.
   */
  endpoint: string
  rev: string
}

export type { EventRateLimitExceeded }

/** Fired when a user exceeds a rate limit. */
const eventRateLimitExceeded =
  /*#__PURE__*/ l.typedObject<EventRateLimitExceeded>(
    $nsid,
    'eventRateLimitExceeded',
    /*#__PURE__*/ l.object({
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      endpoint: /*#__PURE__*/ l.string(),
      rev: /*#__PURE__*/ l.string(),
    }),
  )

export { eventRateLimitExceeded }
